import { Pipe, PipeTransform } from '@angular/core';

import { dayjs } from '@karve.it/core';

@Pipe({
  name: 'jobTimeline',
  standalone: true,
})
export class JobTimelinePipe implements PipeTransform {

  transform(timeline: string, timelineDays: number): string {

    if (!timeline) {
      return 'Not set';
    }

    let str = dayjs(timeline, 'YYYY-MM-DD').format('MMM DD YYYY');

    if (timelineDays === 0) {
      str += ` (Not flexible)`;
    } else if (timelineDays === 1) {
      str += ` (1 day of flexibility)`;
    } else if (timelineDays > 1) {
      str += ` (${timelineDays} days of flexibility)`;
    }

    return str;
  }

}
